import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          {/* Brand Column */}
          <div className="footer-brand">
            <div className="footer-logo-section">
              <img src="/almed-logo.png" alt="ALMED Logo" />
            </div>
            <p className="footer-description">
              {t('footer.description')}
            </p>
            <div className="footer-social">
              <a href="https://facebook.com/almedequip" target="_blank" rel="noopener noreferrer">📘</a>
              <a href="https://twitter.com/almedequip" target="_blank" rel="noopener noreferrer">🐦</a>
              <a href="https://instagram.com/almedequip" target="_blank" rel="noopener noreferrer">📷</a>
              <a href="https://linkedin.com/almedequip" target="_blank" rel="noopener noreferrer">💼</a>
            </div>
          </div>

          {/* Products Column */}
          <div className="footer-column">
            <h4>{t('footer.products')}</h4>
            <ul className="footer-links">
              <li><Link to="/products/ductless-laminar-air-flow-system" className="footer-link">Laminar Air Flow</Link></li>
              <li><Link to="/products/modular-operation-theatre" className="footer-link">Modular OT</Link></li>
              <li><Link to="/products/psa-oxygen-generation-plant" className="footer-link">Oxygen Plant</Link></li>
              <li><Link to="/products/ozone-generator" className="footer-link">Ozone Generator</Link></li>
              <li><Link to="/products/isolation-ward" className="footer-link">Isolation Ward</Link></li>
            </ul>
          </div>

          {/* Company Column */}
          <div className="footer-column">
            <h4>{t('footer.company')}</h4>
            <ul className="footer-links">
              <li><Link to="/about" className="footer-link">{t('nav.about')}</Link></li>
              <li><Link to="/products" className="footer-link">{t('nav.products')}</Link></li>
              <li><Link to="/services" className="footer-link">{t('nav.services')}</Link></li>
              <li><Link to="/gallery" className="footer-link">{t('nav.gallery')}</Link></li>
              <li><Link to="/blog" className="footer-link">{t('nav.blog')}</Link></li>
              <li><Link to="/contact" className="footer-link">{t('nav.contact')}</Link></li>
            </ul>
          </div>

          {/* Contact Column */}
          <div className="footer-column">
            <h4>{t('footer.contact')}</h4>
            <ul className="footer-links">
              <li className="footer-link">📍 Gala No. 16, Ekta Industrial Estate Khan Compound, Tondare, Taloja, Panvel, Navi Mumbai, Maharashtra 410208</li>
              <li><a href="mailto:sales@almedequipment.com" className="footer-link">📧 sales@almedequipment.com</a></li>
              <li><a href="tel:+919322510636" className="footer-link">📞 +91 93225 10636</a></li>
              <li className="footer-link">🕐 {t('contact.info.office')}: Mon-Sat 9:00-18:00</li>
              <li className="footer-link">🏥 {t('contact.info.siteService')}: 24x7</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            {t('footer.copyright')}
          </p>
          <div className="footer-certifications">
            <span>ISO 9001:2008</span>
            <span>NSIC</span>
            <span>MSME</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
